<template>
  <footer class="bg-richBlack border-t border-gold-500/20 py-12">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
        <!-- Brand -->
        <div>
          <h3 class="text-2xl font-display font-bold text-gold-gradient mb-4">شركة النضار</h3>
          <p class="text-gray-400 text-sm">
            شريكك الموثوق في المجوهرات الذهبية الفاخرة وقطع الاستثمار منذ عام 1990.
          </p>
        </div>

        <!-- Quick Links -->
        <div>
          <h4 class="text-lg font-display font-semibold text-gold-400 mb-4">روابط سريعة</h4>
          <ul class="space-y-2">
            <li>
              <a href="#home" class="text-gray-400 hover:text-gold-500 transition-smooth text-sm">
                الرئيسية
              </a>
            </li>
            <li>
              <a href="#about" class="text-gray-400 hover:text-gold-500 transition-smooth text-sm">
                من نحن
              </a>
            </li>
            <li>
              <a href="#products" class="text-gray-400 hover:text-gold-500 transition-smooth text-sm">
                المنتجات
              </a>
            </li>
            <li>
              <a href="#contact" class="text-gray-400 hover:text-gold-500 transition-smooth text-sm">
                اتصل بنا
              </a>
            </li>
          </ul>
        </div>

        <!-- Social Media -->
        <div>
          <h4 class="text-lg font-display font-semibold text-gold-400 mb-4">تواصل معنا</h4>
          <div class="flex space-x-3 space-x-reverse">
            <a href="https://www.instagram.com/fm.gold_qasar?utm_source=qr&igsh=d3Nmcm94NnJwZDNy" target="_blank"
              rel="noopener noreferrer"
              class="w-10 h-10 bg-gold-500/20 hover:bg-gold-500 rounded-lg flex items-center justify-center transition-smooth group"
              aria-label="Instagram">
              <Instagram class="text-gold-500 group-hover:text-richBlack transition-smooth" :size="18" />
            </a>
            <a href="https://www.tiktok.com/@fras.ali86?_r=1&_t=ZS-91r8N4XYyG5" target="_blank"
              rel="noopener noreferrer"
              class="w-10 h-10 bg-gold-500/20 hover:bg-gold-500 rounded-lg flex items-center justify-center transition-smooth group"
              aria-label="Tiktok">
              <TiktokIcon :size="18" class-name="text-gold-500 group-hover:text-richBlack transition-smooth" />
            </a>
          </div>
        </div>
      </div>

      <!-- Copyright -->
      <div class="border-t border-gold-500/20 pt-8 text-center">
        <p class="text-gray-500 text-sm">
          جميع الحقوق محفوظة لصالح شركة النضار لتجارة واستيراد الذهب والمجوهرات &copy; {{ currentYear }}
        </p>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { computed } from 'vue'
import { Instagram } from 'lucide-vue-next'
import TiktokIcon from './icons/TiktokIcon.vue'

// Get current year dynamically
const currentYear = computed(() => new Date().getFullYear())
</script>
